<template>
  <header class="mb-3 mb-xl-5">
    <b-navbar toggleable="lg" type="dark" variant="boxx-grey">
      <b-container>
        <b-navbar-brand>
          <router-link :to="{ name: 'bookings' }">
            <img
              src="@/assets/img/logo/boxx-mini-white.svg"
              alt="BOXX Barber Shop logo"
              height="20"
              style="margin-top: -4px"
            />
          </router-link>
        </b-navbar-brand>
        <!-- <strong class="nav-link text-warning d-lg-none">DEMO SYSTEM</strong> -->
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <!-- Left aligned nav items -->
          <b-navbar-nav>
            <router-link tag="b-nav-item" :to="{ name: 'bookings' }">
              Bookings
            </router-link>
            <router-link tag="b-nav-item" :to="{ name: 'roster' }">
              Roster
            </router-link>
            <b-nav-item-dropdown text="Manage">
              <router-link tag="b-dropdown-item" :to="{ name: 'resources' }">
                Barbers
              </router-link>
              <router-link tag="b-dropdown-item" :to="{ name: 'services' }">
                Services
              </router-link>
              <router-link tag="b-dropdown-item" :to="{ name: 'packages' }">
                Packages
              </router-link>
            </b-nav-item-dropdown>
            <b-nav-item-dropdown text="Settings">
              <router-link
                tag="b-dropdown-item"
                :to="{ name: 'store-settings' }"
              >
                Store Settings
              </router-link>
            </b-nav-item-dropdown>
            <!-- <strong class="nav-link text-warning d-none d-lg-inline-block ml-3">
              DEMO SYSTEM
            </strong> -->
          </b-navbar-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-item-dropdown right>
              <!-- Using 'button-content' slot -->
              <template v-slot:button-content>
                {{ store.name }}
              </template>
              <b-dropdown-item
                v-for="item in stores"
                :key="item.name"
                :active="item === store"
                @click.prevent="changeStore(item)"
              >
                {{ item.name }}
              </b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item-button
                variant="danger"
                @click.prevent="onLogout"
              >
                Logout
              </b-dropdown-item-button>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>
  </header>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  computed: mapGetters({
    store: 'stores/store',
    stores: 'stores/storesExcludingCurrentStore'
  }),
  methods: {
    ...mapActions({
      logout: 'auth/logout',
      setStore: 'stores/setStore'
    }),
    changeStore(newStore) {
      this.$router.push(this.$route.path.replace(this.store._id, newStore._id));
      this.setStore(newStore._id);
    },
    async onLogout() {
      await this.logout();
      this.$router.push('/admin/login');
    }
  }
};
</script>
